// Create plural rules for time units
const pluralRules = new Intl.PluralRules("en-US");

// Map of time units to their singular/plural forms
const timeUnits = {
  day: { one: "Day", other: "Days" },
  hour: { one: "Hour", other: "Hours" },
  minute: { one: "Minute", other: "Minutes" },
  second: { one: "Second", other: "Seconds" },
};

/**
 * Calculate time remaining from a target date
 * @param {Date} targetDate - The target date to count down to
 * @returns {Object} Object containing time units
 */
export const calculateTimeLeft = (targetDate) => {
  const now = new Date().getTime();
  const difference = targetDate.getTime() - now;

  if (difference <= 0) {
    return {
      timeLeft: { days: 0, hours: 0, minutes: 0, seconds: 0 },
    };
  }

  return {
    timeLeft: {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((difference % (1000 * 60)) / 1000),
    },
  };
};

/**
 * Get the most significant time unit and its plural form
 * @param {Object} timeLeft - Object containing time units
 * @returns {Object} Object containing the value and unit with proper pluralization
 */
export const getMostSignificantTime = (timeLeft) => {
  if (timeLeft.days > 0) {
    const rule = pluralRules.select(timeLeft.days);
    return {
      value: timeLeft.days,
      unit: timeUnits.day[rule],
    };
  }
  if (timeLeft.hours > 0) {
    const rule = pluralRules.select(timeLeft.hours);
    return {
      value: timeLeft.hours,
      unit: timeUnits.hour[rule],
    };
  }
  if (timeLeft.minutes > 0) {
    const rule = pluralRules.select(timeLeft.minutes);
    return {
      value: timeLeft.minutes,
      unit: timeUnits.minute[rule],
    };
  }
  const rule = pluralRules.select(timeLeft.seconds);
  return {
    value: timeLeft.seconds,
    unit: timeUnits.second[rule],
  };
};
